import React from "react"
import PropTypes from 'prop-types'

import {Wrapper} from './FooterStyle'

const Footer = ({siteTitle})=> {
  return (
    <Wrapper>
      <p>© 2019 - {siteTitle}</p>
    </Wrapper>
  )
}

Footer.propTypes = {
  siteTitle: PropTypes.string
}

Footer.defaultProps = {
  siteTitle: ``
}
export default Footer
